
<div class="container-menu">
  <div class="row align-items-center px-3 py-2">
    <div class="col-9">
      <h2 class="color-white mb-0">Menu</h2>
    </div>
    <div class="col-3 text-end pe-2">
      <button (click)="closemenu()" mat-icon-button  class="color-white"  >
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

<mat-divider></mat-divider>
  <mat-list class="container-menu__lista" role="list">
    <mat-list-item *ngFor="let item of listMenu" class="container-menu__lista__items">
      <a [routerLink]="item.patch" class="container-menu__lista__items__link" [routerLinkActive]="'container-menu__lista__items__link-active'">
        <mat-icon>{{item.icon}}</mat-icon>
        <span>{{item.label}}</span>
      </a>
    </mat-list-item>

  </mat-list>
  <small class="d-block text-center mt-4 color-white">Adminstrador</small>
  <small class="d-block text-center mt-1 color-white">{{version}}</small>
</div>


